(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7741],{

/***/ 48939:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/modern-slavery-statement",
      function () {
        return __webpack_require__(53196);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ ModernSlaveryHub; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 120 modules
var src = __webpack_require__(99313);
// EXTERNAL MODULE: ../../../libs/landing/feature-modern-slavery-hub/src/lib/feature-modern-slavery-hub.module.css
var feature_modern_slavery_hub_module = __webpack_require__(34298);
var feature_modern_slavery_hub_module_default = /*#__PURE__*/__webpack_require__.n(feature_modern_slavery_hub_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-modern-slavery-hub/src/lib/feature-modern-slavery-hub.tsx



const ModernSlaveryHub = ({ links  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (feature_modern_slavery_hub_module_default()).linkContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Wrapper */.im, {
            isSlim: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: links.sort((a, b)=>Number(b.name) - Number(a.name)).map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (feature_modern_slavery_hub_module_default()).link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: `/${link.slug.replace("statements/", "")}`,
                            children: [
                                "Modern slavery statement ",
                                link.name
                            ]
                        })
                    }, link.name))
            })
        })
    });

// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var storyblok_src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-modern-slavery-hub/src/lib/get-static-props.ts


async function getStaticPropsFn({ preview =false  }) {
    try {
        var ref, ref1;
        (0,datadog_server_src/* setTag */.YA)("page.name", "modern-slavery-hub");
        (0,datadog_server_src/* setTag */.YA)("page.rendered", "ISR");
        (0,datadog_server_src/* setTag */.YA)("page.revalidate-in", "60s");
        (0,datadog_server_src/* setTag */.YA)("page.params", JSON.stringify({
            preview
        }, null, 2));
        const links = await (0,storyblok_src/* getLinks */.rx)("policies/modern-slavery-statement/statements");
        const story = await (0,storyblok_src/* getStoryBySlug */.OI)("policies/modern-slavery-statement/index");
        const actualLinks = Object.values(links).filter((link)=>link.published === true);
        if (!story) {
            throw new Error("No story found within modern slavery");
        }
        const HeroProps = story === null || story === void 0 ? void 0 : (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.hero) === null || ref1 === void 0 ? void 0 : ref1[0];
        (0,datadog_server_src/* setTag */.YA)("page.response-code", 200);
        return {
            props: {
                preview,
                links: actualLinks,
                layoutProps: {
                    showBorderRadius: false,
                    heroProps: HeroProps
                }
            },
            revalidate: 60
        };
    } catch (error) {
        if (error instanceof Error || typeof error === "string") {
            (0,datadog_server_src/* tagError */.$k)(error);
        }
        (0,datadog_server_src/* setTag */.YA)("page.response-code", 404);
        return {
            notFound: true,
            props: {
                links: [],
                layoutProps: {
                    showBorderRadius: false,
                    heroProps: []
                }
            },
            revalidate: 60
        };
    }
}
const getStaticProps = (0,datadog_server_src/* traceFunction */.KG)("modernSlaveryHub.getStaticProps", getStaticPropsFn);

;// CONCATENATED MODULE: ../../../libs/landing/feature-modern-slavery-hub/src/index.ts



;// CONCATENATED MODULE: ./pages/policies/modern-slavery-statement/index.tsx
var __N_SSG = true;



/***/ }),

/***/ 34298:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"background":"feature-modern-slavery-hub_background__OByi_","container":"feature-modern-slavery-hub_container__B7Klj","heading":"feature-modern-slavery-hub_heading__RqG84","linkContainer":"feature-modern-slavery-hub_linkContainer__KmLll","link":"feature-modern-slavery-hub_link__WOBUg"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(48939); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);